var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-amount" },
    [
      _c(
        "CompassFormItem",
        _vm._b(
          { attrs: { error: _vm.field.currentError || "" } },
          "CompassFormItem",
          _vm.formItemProps,
          false
        ),
        [
          _c("CompassInput", {
            attrs: {
              value: _vm.localValue,
              type: "number",
              min: 0,
              menuClass: "automation-wizard-field-amount"
            },
            on: { input: _vm.handleInput, blur: _vm.handleBlur },
            scopedSlots: _vm._u([
              {
                key: "suffix",
                fn: function() {
                  return [
                    _c(
                      "span",
                      {
                        staticClass:
                          "automation-wizard-field-amount__suffix typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.currencySymbol) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }